/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

export enum AuthMethodUsage {
  Client = 'Client',
  Office = 'Office',
  Outsider = 'Outsider'
}
